import React from 'react'
import { AiOutlineCheck } from "react-icons/ai";
import { HiOutlineStatusOffline } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';

const User = ({pic,status,id,showDummyImage,resulution}) => {
  const navigate = useNavigate();
  const redirectUrl = () => {
    navigate(`/profile/${id || 1}/#header`)
  }
  return (
    <div onClick={redirectUrl} className="user">
      <div className="user-img">
        <img src={pic} alt={pic} onError={({currentTarget},imageSize=resulution)=>showDummyImage({currentTarget},imageSize)}/>
      </div>
      <div className={status ? "user-status" : "user-offline"}>
        {status ? <AiOutlineCheck /> : <HiOutlineStatusOffline />}
      </div>
    </div>
  );
}

export default User


